import util from '../util'

let controller = 'AprovacaoTransacao'

export default Object.assign({}, util.GetCrud(controller,
    ['get', 'getall']
), {
    GetMovimentosEmAnalise: function (dto) {
        return util.Axios.GetAll(controller + '/MovimentosEmAnalise', dto)
    },
    Operadores: function (id) {
        return util.Axios.Get(controller + '/OperadoresAprovadores', id)
    },
    DetalhesTransacao: function (id) {
        return util.Axios.Get(controller + '/DetalhesTransacao', id)
    },
    ReprovarTransacao: function (id) {
        return util.Axios.Put(controller + '/ReprovarTransacao', id)
    },

})
